/**
 * <LienPage to="/referentiels/tiers/42" label="Biogaz du Vercors" /> : lien vers un autre écran (clic = dans la page,
 * Ctrl/⌘ + clic = nouvelle page) suivi d'une petite icône « Ouvrir dans une nouvelle page ». À utiliser dès qu'un
 * écran rebondit vers un autre (le ticket → l'employé, la fiche → le tiers…).
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Icon, cx } from '../../design';
import { useT } from '../i18n';
import { useActionsEspace } from './espace';

export interface LienPageProps {
  /** Adresse de l'écran cible (chemin absolu). */
  to: string;
  /** Texte du lien (et de l'info-bulle de l'icône). */
  label: string;
  /** Contenu du lien s'il diffère du texte (drapeau + code…). */
  children?: React.ReactNode;
  className?: string;
}

export function LienPage({ to, label, children, className }: LienPageProps) {
  const { t } = useT();
  const { ouvrir } = useActionsEspace();
  const aide = `${t('dock.ouvrirDansPage')} : ${label}`;
  return (
    <span className={cx('agx-lien-page', className)}>
      <Link to={to} className="agx-lien" onClick={(e) => e.stopPropagation()}>{children ?? label}</Link>
      <button
        type="button" className="agx-btn-page" aria-label={aide} title={t('dock.ouvrirDansPage')}
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); ouvrir(to, { nouvellePage: true }); }}
      >
        <Icon name="layers" size={14} />
      </button>
    </span>
  );
}
